import { useState, useEffect, useRef } from "react";
import "@/App.css";
import StarField from "@/components/StarField";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import StatsSection from "@/components/StatsSection";
import EcosystemSection from "@/components/EcosystemSection";
import TechSection from "@/components/TechSection";
import CinematicSection from "@/components/CinematicSection";
import Footer from "@/components/Footer";

function App() {
  const [showParticles, setShowParticles] = useState(true);
  const cinematicRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (cinematicRef.current) {
        const rect = cinematicRef.current.getBoundingClientRect();
        setShowParticles(rect.top > 100);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-deepSpace text-offWhite font-sans">
      {/* Vignette for cinematic depth */}
      <div className="vignette" />

      <div
        className="transition-opacity duration-700"
        style={{ opacity: showParticles ? 1 : 0 }}
      >
        <StarField />
      </div>
      <Navbar />
      <HeroSection />

      <div className="section-divider" />
      <div className="relative">
        <div className="ambient-glow-left" />
        <StatsSection />
      </div>

      <div className="section-divider" />
      <div className="relative">
        <div className="ambient-glow-right" />
        <EcosystemSection />
      </div>

      <div className="section-divider" />
      <div className="relative">
        <div className="ambient-glow-left" style={{ top: '30%' }} />
        <TechSection />
      </div>

      <div ref={cinematicRef}>
        <CinematicSection />
      </div>

      <Footer />
    </div>
  );
}

export default App;
